import { Action } from '../../../../../shared/xs/actions';

export class SetReportLanguageAction implements Action {
  static readonly type = '[Slider] update slider language';

  constructor(public language: 'nl' | 'gb') {}
}
